export default "__VITE_ASSET__CjPuyLGi__"